export type Theme = 'system' | 'light' | 'dark';

const KEY = 'cg.theme';

function getTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY);
    if (t === 'light' || t === 'dark') return t;
  } catch {
    /* storage unavailable */
  }
  return 'system';
}

/** Apply a theme: 'system' follows the OS (no attribute), 'light'/'dark' force it. */
function applyTheme(theme: Theme) {
  const root = document.documentElement;
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
}

/** Call once at startup so the saved theme is in place before anything renders. */
export function initTheme() {
  applyTheme(getTheme());
}
